import {saveData, getData} from 'helpers/cache/cacheManager'

function buildKey(presentation_uid, pincode) {
	return `Lead:${presentation_uid}_${pincode}`
}

function addLead(session, name, optionalName) {
	const key = buildKey(session.presentation_uid, session.pincode)
	const saveFields = {
		name,
		optionalName,
	}
	saveData(key, saveFields)
}

async function getLead(session) {
	const key = buildKey(session.presentation_uid, session.pincode)
	const leadData = await getData(key)
	return leadData
}

function addLastNicknameUserLoggedSigned(pincode, name) {
	saveData(`lastNicknameUserLoggedSigned_${pincode}`, name)
}

async function getLastNicknameUserLoggedSigned(pincode) {
	const lastNicknameUserLoggedSigned = await getData(`lastNicknameUserLoggedSigned_${pincode}`)
	return lastNicknameUserLoggedSigned
}

export {
	addLead,
	getLead,
	addLastNicknameUserLoggedSigned,
	getLastNicknameUserLoggedSigned,
}
